import {useMutation} from 'react-query';
import {updateProfile} from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

const useUpdateUserProfile = () => {
  const {
    isLoading,
    mutate: editProfile,
    isSuccess,
  } = useMutation({
    mutationFn: (payload: IUpdateUserProfilePayload) => {
      return updateProfile(payload);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {UpLoadUpdateisLoading: isLoading, editProfile, isSuccess};
};

export default useUpdateUserProfile;
